function deepOverride <T> (original: T, override: object): T {
  const overrider = Object.keys(override).reduce(
    (reduction, key) => {
      const value = override[key]

      if (typeof value === 'object' && value !== null) {
        return {
          ...reduction,
          [key]: deepOverride(original[key], override[key]),
        }
      }

      return {
        ...reduction,
        [key]: value,
      }
    },
    {},
  )

  /* typescript ftw */
  const foo: any = original

  return {
    ...foo,
    ...overrider,
  }
}

export default deepOverride



// WEBPACK FOOTER //
// ./src/utils/deep-override.ts